export default function ConstructorElem(html, components, questions) {
  this.html = html;
  this.components = components;
  this.questions = questions;
}
